import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminShell from "@/components/AdminShell";
import api from "@/lib/api";
import { Users, UserCheck, ShieldCheck, Building2, Briefcase, FileText, Star, CalendarClock, Award, ClipboardList, ArrowRight } from "lucide-react";

const CARDS = [
  { key: "total_candidates", label: "Total Candidates", icon: Users },
  { key: "active_candidates", label: "Active Candidates", icon: UserCheck },
  { key: "verified_candidates", label: "Verified Candidates", icon: ShieldCheck },
  { key: "total_employers", label: "Total Employers", icon: Building2 },
  { key: "verified_employers", label: "Verified Employers", icon: ShieldCheck },
  { key: "active_jobs", label: "Active Jobs", icon: Briefcase },
  { key: "total_applications", label: "Applications", icon: FileText },
  { key: "shortlisted", label: "Shortlisted", icon: Star },
  { key: "interviews", label: "Interviews", icon: CalendarClock },
  { key: "hired", label: "Hired", icon: Award },
];

export default function AdminDashboard() {
  const [stats, setStats] = useState({});
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  return (
    <AdminShell>
      <h1 className="font-display text-2xl font-bold text-slate-900">Admin Dashboard</h1>
      <p className="text-slate-500 text-sm mt-1">Enterprise recruitment control center for the cable & conductor industry.</p>

      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-3 mt-6">
        {CARDS.map((c) => (
          <div key={c.key} data-testid={`admin-stat-${c.key}`} className="bg-white rounded-xl border border-slate-200 p-4">
            <div className="flex items-center justify-between">
              <c.icon className="w-5 h-5 text-[#D96B27]" />
            </div>
            <div className="font-display text-3xl font-extrabold text-slate-900 mt-2">{stats[c.key] ?? 0}</div>
            <div className="text-xs text-slate-500 mt-0.5">{c.label}</div>
          </div>
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-4 mt-6">
        <Link to="/admin/candidates" className="group bg-slate-900 text-white rounded-2xl p-7 hover:shadow-xl transition-all overflow-hidden relative">
          <div className="absolute inset-0 hero-grid opacity-30" />
          <div className="relative">
            <Users className="w-8 h-8 text-[#D96B27]" />
            <h3 className="font-display text-xl font-bold mt-3">Candidate Database Search</h3>
            <p className="text-sm text-slate-300 mt-1">Filter {stats.total_candidates ?? 0} specialist profiles with smart match scoring.</p>
            <span className="inline-flex items-center gap-1 text-[#D96B27] font-medium text-sm mt-4 group-hover:gap-2 transition-all">Open search <ArrowRight className="w-4 h-4" /></span>
          </div>
        </Link>
        <Link to="/admin/requirements" className="group bg-white border border-slate-200 rounded-2xl p-7 hover:shadow-md transition-all">
          <ClipboardList className="w-8 h-8 text-[#D96B27]" />
          <h3 className="font-display text-xl font-bold mt-3 text-slate-900">Recruitment Requirements</h3>
          <p className="text-sm text-slate-500 mt-1">Create client requirements and auto-match candidates from the database.</p>
          <span className="inline-flex items-center gap-1 text-[#D96B27] font-medium text-sm mt-4 group-hover:gap-2 transition-all">Manage requirements <ArrowRight className="w-4 h-4" /></span>
        </Link>
      </div>
    </AdminShell>
  );
}
